"use client";

import { NotificationProps, NotificationStatus } from "@/lib/declarations";
import useSWRFetcher from "./use-swr-fetcher";
import { KeyedMutator } from "swr";
import { useEffect, useRef } from "react";

export default function useNotification(isLoggedIn: boolean, fallback?: (notification: NotificationProps) => void) {
  const lastDataRef = useRef<NotificationProps[] | null>(null);
  const enableNotification =
    typeof process.env.NEXT_PUBLIC_ENABLE_NOTIFICATION !== "undefined" &&
    process.env.NEXT_PUBLIC_ENABLE_NOTIFICATION === "true";
  const { data, mutate } = useSWRFetcher<NotificationProps[]>(enableNotification && isLoggedIn && "/api/notification", {
    refreshInterval: 5 * 1000,
  });

  useEffect(() => {
    if (!data) return;
    if (lastDataRef.current) {
      if (data.length > lastDataRef.current.length) {
        const newNotices = data.filter((e) => e.status === NotificationStatus.UNREAD.toString());
        console.log(newNotices);
        fallback?.(newNotices[0]);
      }
    }
    lastDataRef.current = data;
  }, [data]);

  return [data, mutate] as [NotificationProps[], KeyedMutator<NotificationProps[]>];
}
